import { InputProps } from 'components/inputs/types'

export type AddressProps = InputProps & {
  hasRegionField?: boolean
  hideTownSelectField?: boolean
  hideErrorMessage?: boolean
  setFetchingTowns?: (state: boolean) => void
}

export enum AddressFields {
  POSTAL_CODE = 'postalCode',
  STREET_BOX = 'streetBox',
  STREET_NAME = 'streetName',
  STREET_NUMBER = 'streetNumber',
  TOWN_CODE = 'townCode',
  TOWN_NAME = 'townName',
  REGION = 'region',
  COUNTRY_CODE = 'countryCode'
}
